import { HttpService } from "../index";

export class UserManagementService {

    constructor (
        protected httpService:HttpService
    ) {}

    createUser(user:any) : Promise<any> {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.post('/api/v1/users', user)
                .then((response) => {
                    resolve(response.json());
                })
                .catch(() => {
                    reject();
                });
        });
    }

    updateUser(id:any, user:any) : Promise<any> {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.put('/api/v1/users/' + id, user)
                .then((response) => {
                    resolve(response.json());
                })
                .catch(() => {
                    reject();
                });
        });
    }

    getUser(id:any) : Promise<any> {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.get('/api/v1/users/' + id)
                .then((response) => {
                    resolve(response.json());
                })
                .catch(() => {
                    reject();
                });
        });
    }

    listUsers() : Promise<any[]> {
        return new Promise<any[]> ( (resolve, reject) => {
            this.httpService.get('/api/v1/users')
                .then((response) => {
                    resolve(response.json());
                })
                .catch(() => {
                    reject();
                });

        });
    }
}


// WEBPACK FOOTER //
// ./src/services/user-managment/user-management-service.ts